import { Exclude, Expose, Type } from 'class-transformer';

@Exclude()
export class UserEditModel {
  @Expose()
  userId: number;

  @Expose()
  email: string;

  @Expose()
  firstName: string;

  @Expose()
  lastName: string;

  @Expose()
  mobileNumber: string;

  @Expose()
  companyId?: number | null;
}

@Exclude()
export class CreateUserRequest {
  @Expose()
  email: string;

  @Expose()
  firstName: string;

  @Expose()
  lastName: string;

  @Expose()
  phoneNumber?: string;

  @Expose()
  addressLine1?: string;

  @Expose()
  addressLine2?: string;

  @Expose()
  suburb?: string;

  @Expose()
  postcode?: string;

  @Expose()
  state?: string;

  @Expose()
  country?: string;

  @Expose()
  tcAccepted: boolean;

  @Expose()
  persona?: string;

  @Expose()
  mobileNumber?: string;
}

@Exclude()
export class GenericResult {
  @Expose()
  success: boolean;

  @Expose()
  message?: string;
}

export enum UserCreationActionTypes {
  CanNotCreate = 1,
  CanCreate,
  AlreadyExists,
}

@Exclude()
export class UserStatusModel {
  @Expose()
  userCreationAction: UserCreationActionTypes;

  @Expose()
  userId?: number | null;

  @Expose()
  companyId?: number | null;
}

@Exclude()
export class CurrentUserStatusModel {
  @Expose()
  hasCompany: boolean;
}

@Exclude()
export class UserSearchModel {
  @Expose()
  id: number;

  @Expose()
  email: string;

  @Expose()
  firstName: string;

  @Expose()
  lastName: string;

  @Expose()
  companyName: string;
}

@Exclude()
export class UserFlockModel {
  @Expose()
  breedFlockCode: string;

  @Expose()
  flockName: string;

  @Expose()
  breedId: string;

  @Expose()
  breedTitle: string;

  @Expose()
  species: string;

  @Expose()
  status: string;

  @Expose()
  type: string;

  @Expose()
  pics?: string[] | null;

  @Expose()
  companyId?: number | null;

  @Expose()
  companyName: string;

  @Expose()
  source: string;
}

@Exclude()
export class UserInfoModel {
  @Expose()
  id: number;

  @Expose()
  email: string;

  @Expose()
  firstName: string;

  @Expose()
  lastName: string;

  @Expose()
  mobile: string;

  @Expose()
  phone: string;

  @Expose()
  companyId?: number | null;

  @Expose()
  companyName: string;
}

@Exclude()
export class UserDetailModel {
  @Expose()
  @Type(() => UserInfoModel)
  user: UserInfoModel;

  @Expose()
  @Type(() => UserFlockModel)
  flocks: UserFlockModel[];
}
